/**
 * @generated SignedSource<<5d0a1c083c2550f5508e14332602f03a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationColumn_notification$data = {
  readonly title: string;
  readonly body: string | null;
  readonly " $fragmentType": "NotificationColumn_notification";
};
export type NotificationColumn_notification = NotificationColumn_notification$data;
export type NotificationColumn_notification$key = {
  readonly " $data"?: NotificationColumn_notification$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationColumn_notification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationColumn_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    }
  ],
  "type": "Notification",
  "abstractKey": null
};

(node as any).hash = "ff9577cdefa1821dc2ae77e6a01ec7b5";

export default node;
